export function autoHypenPhone(str) {
    str = str.replace(/[^0-9]/g, '')
    var tmp = ''
    if (str.length < 4) {
        return str
    } else if (str.length < 7) {
        tmp += str.substr(0, 3)
        tmp += '-'
        tmp += str.substr(3)
        return tmp
    } else if (str.length < 11) {
        if (str.substr(0, 2) === '02' && str.length === 9) {
            tmp += str.substr(0, 2)
            tmp += '-'
            tmp += str.substr(2, 3)
            tmp += '-'
            tmp += str.substr(5)
        } else {
            tmp += str.substr(0, 3)
            tmp += '-'
            tmp += str.substr(3, 3)
            tmp += '-'
            tmp += str.substr(6)
        }
        return tmp
    } else {
        tmp += str.substr(0, 3)
        tmp += '-'
        tmp += str.substr(3, 4)
        tmp += '-'
        tmp += str.substr(7)
        return tmp
    }
}